import React, { Component } from 'react'
import { throttle } from 'lodash'

import LandingHeader from 'components/LandingHeader'
import Header from 'components/Header'
import Sidebar from 'components/Sidebar'
import ModalContainer from 'features/Modal/ModalContainer'
import ToastsContainer from 'features/Toasts'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default class AppRoot extends Component {
  componentDidMount() {
    const { setAtTop } = this.props

    // Window scroll handler (only used for small screens)
    const scrollHandler = throttle(() => setAtTop(window.scrollY === 0), 50)
    window.addEventListener('scroll', scrollHandler)
  }
  render() {
    const { layout, children, location } = this.props
    return (
      <div className={cn(sLay['layout-row'], sLay.flex)} style={{ minHeight: '0px' }}>
        <Sidebar pathname={location.pathname} />
        <div className={cn(sLay['layout-column'], sLay.flex)} style={{ position: 'relative' }}>
          {layout.header === 'landing' && <LandingHeader location={location} />}
          {layout.header === 'app' && <Header location={location} />}
          {children}
        </div>
        <ModalContainer />
        <ToastsContainer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/AppRoot/AppRoot.jsx